import React from 'react';
import Icon from '../Icon';
import { tie } from '../page/typography';
import StepNumber from '../page/StepNumber';
import { bodyText } from './prose';

/**
 * Один сценарій «що робити»: заголовок і кроки по черзі.
 *
 * Кроки нумеровані: людина виконує їх один за одним і повертається до
 * списку, щоб звіритися, де зупинилась. Лінія між номерами тримає їх як
 * одну послідовність, а не як окремі пункти.
 *
 * Кожен сценарій — окрема картка зі своїм якорем: хто вже подав Відомості,
 * переходить зі змісту одразу до свого й не читає чужі кроки.
 *
 * `tone="warn"` — для сценарію, де строк уже пропущено.
 */
const TONES = {
  warn: { icon: 'fa-exclamation-circle', tile: 'border-amber-200 bg-amber-50 text-amber-600' },
  ok: { icon: 'fa-check-circle', tile: 'border-teal-100 bg-teal-50 text-teal-700' }
};

const StepGroup = ({ id, title, steps = [], tone = 'ok' }) => {
  const t = TONES[tone] || TONES.ok;
  return (
    <section id={id} aria-labelledby={`${id}-title`} className="scroll-mt-28 rounded-2xl border border-slate-200 bg-white p-4 sm:p-7">
      <div className="flex items-center gap-3">
        <span className={`flex-shrink-0 w-10 h-10 rounded-xl border flex items-center justify-center ${t.tile}`} aria-hidden="true">
          <Icon name={t.icon} />
        </span>
        <h3 id={`${id}-title`} className="font-display text-lg lg:text-xl font-bold leading-snug text-slate-900 text-balance">
          {tie(title)}
        </h3>
      </div>

      <ol className="list-none m-0 p-0 mt-6 space-y-5">
        {steps.map((step, i) => (
          <li key={step.slice(0, 40)} className="relative flex gap-3 sm:gap-4">
            {i < steps.length - 1 && (
              <span className="absolute left-4 top-10 -bottom-4 w-px bg-teal-200" aria-hidden="true"></span>
            )}
            <StepNumber n={i + 1} size="sm" className="mt-0.5" />
            <p className={`${bodyText} min-w-0 text-slate-700`}>{tie(step)}</p>
          </li>
        ))}
      </ol>
    </section>
  );
};

export default StepGroup;
